import { lazy } from 'react';
import { ComponentsMapInterface } from './types';

export enum ComponentsMapEnums {
  JOB_REQUISITIONS,
  JOB_REQUISITIONS_VIEW,
  CANDIDATE_APPLICATION_STATUS,
  // CANDIDATE_INTERVIEW_STATUS,
  CANDIDATE_ONBOARDING,
  INTERVIEW_CANDIDATE_VIEW,
  CANDIDATE_PRE_ONBOARDING,
}

export const ComponentsMap: ComponentsMapInterface = {
  JOB_REQUISITIONS: lazy(() => import('../pages/job-requisitions')),
  JOB_REQUISITIONS_VIEW: lazy(() => import('../pages/job-requisitions-view')),
  CANDIDATE_APPLICATION_STATUS: lazy(
    () => import('../pages/candidate-application-status'),
  ),
  CANDIDATE_PRE_ONBOARDING: lazy(
    () => import('../pages/candidate-pre-onboarding'),
  ),
  // CANDIDATE_INTERVIEW_STATUS: lazy(
  //   () => import('../pages/candidate-interview-status'),
  // ),
  CANDIDATE_ONBOARDING: lazy(() => import('../pages/candidate-onboarding')),
  INTERVIEW_CANDIDATE_VIEW: lazy(
    () => import('../pages/candidate-interviewer-view'),
  ),
};
